import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import { useAppLayoutContextValue } from "#app-layout-context-value";

export const AppLayoutContext = createContext(
  defaultError<ReturnType<typeof useAppLayoutContextValue>>("AppLayoutContext"),
);
